(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pro-gallery-renderer", [], factory);
	else if(typeof exports === 'object')
		exports["pro-gallery-renderer"] = factory();
	else
		root["pro-gallery-renderer"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition